import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Databasearchive } from '../databasearchive/databasearchive';

let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');
@Injectable({
  providedIn: 'root'
})
export class DatabasearchiveService {

  baseUrl: string = environment.serviceUrl;
  constructor(private httpClient: HttpClient) { } 

  //httpclient get method
  Get(): Observable<Databasearchive[]> {
   
    return this.httpClient.get<Databasearchive[]>(this.baseUrl + 'api/DatabaseArchiveAPI/');
  };

  //httpclient get state
  loadstate(): Observable<Databasearchive[]> {
    return this.httpClient.get<Databasearchive[]>(this.baseUrl + 'api/DatabaseArchiveAPI/loadstate');
  };


  //httpclient get method
  loadarchivedata(): Observable<Databasearchive[]> {
    return this.httpClient.get<Databasearchive[]>(this.baseUrl + 'api/DatabaseArchiveAPI/loadarchivedata');
  };


  getCurrentYear(): Observable<Databasearchive[]> {
      return this.httpClient.get<Databasearchive[]>(this.baseUrl + 'api/DatabaseArchiveAPI/getCurrentYear');
  };

  Post(_mailtemModel: Databasearchive): Observable<any> {
 
    return this.httpClient.post<any>(this.baseUrl + 'api/DatabaseArchiveAPI/AddTable', _mailtemModel, { headers: header, observe: 'response' });
  }  
}
